import { Component, Input } from "@angular/core";
import { AggregateCriteria, IAggregate } from "@tylertech/tyler-api-types";

import { AggregateHelperService } from "../../services";

@Component({
    selector: "standard-task",
    templateUrl: "./standardTask.tmpl.html",
    standalone: false
})
export class StandardTaskComponent
{
    @Input()
    aggregate: IAggregate;

    @Input()
    aggregateCriteria: AggregateCriteria;

    constructor(
        private readonly $aggregateHelperService: AggregateHelperService)
    { }

    get isHidden(): boolean
    {
        return this.$aggregateHelperService.isHidden(this.aggregate);
    }
}
